import { createAsyncThunk } from '@reduxjs/toolkit';
import { Training } from './trainingTypes';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';



export const createTraining = createAsyncThunk(
    'training/createTraining',
    async (formData : Training ,  {rejectWithValue}) =>{
        try {
           const response = await employeeServiceApiInstance.post('/training', formData);
          return response.data;
        } catch (error : any) {
            return rejectWithValue(error.response?.data || 'Failed to create training');
        }
    }
)

export const updatetraining = createAsyncThunk(
    'training/updateTraining',
    async ({ id, data }: { id: number; data: Training }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/training/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update training');
        }
    }
);

export const fetchAlltraininglist = createAsyncThunk(
    'training/fetchAlltraining',
    async (_, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get('/training');
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch training Details');
      }
    }
  );

  export const deletetraininglistById = createAsyncThunk(
    'training/deletetraininglistById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.delete(`/training/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Delete');
      }
    }
  );

  export const gettraininglistById = createAsyncThunk(
    'training/gettraininglistById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/training/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to get');
      }
    }
  );

  export const gettraininglistemployeeWise = createAsyncThunk(
    'training/gettraininglistById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/training/employee/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to get');
      }
    }
  );

